import React from 'react';
import {List, Map, Set} from 'immutable';
import User, {UserId} from 'records/User';
import {UserComment} from 'records/UserComment';
import './CommentSectionFull.sass';
import {UserCommentRow} from '@components/call-card/UserCommentRow';
import {PlayerProps} from '@components/call-card/Player.utils';
import Button from '@material-ui/core/Button';
import {CommentIcon} from '@components/icon/CommentIcon';
import {DragStatus} from '@store/call-card/CallCard.types';
import {Call} from '@store/call-card/Call';
import {SetState} from '@store/@types/util/React';
import {Seconds} from '@store/@types/util';

interface CommentSectionFullProps extends PlayerProps {
  comments: Map<UserId, List<UserComment>>;
  sessionUser: User;
  call: Call;
  dragStatus: DragStatus;
  newComment: UserComment | undefined;
  setNewComment: SetState<UserComment | undefined>;
  directReports: Set<UserId>;
  setTimeSeconds: (seconds: Seconds) => void;
  playRecording: () => void;
}

export const CommentSectionFull: React.FC<CommentSectionFullProps> = ({
  comments,
  sessionUser,
  call,
  newComment,
  setNewComment,
  dragStatus,
  directReports,
  setTimeSeconds,
  playRecording,
  ...playerProps
}) => {
  return (
    <div className="comment-section-full">
      <h3 className="header">Comments</h3>
      <Button
        size="small"
        className="comment-button"
        variant="outlined"
        color="primary"
        onClick={() =>
          setNewComment(
            new UserComment({
              message: '',
              userId: sessionUser.id,
              startTime: playerProps.currentTime,
              endTime: playerProps.currentTime,
            })
          )
        }>
        <CommentIcon />
        Add
      </Button>
      <div className="comment-tracks">
        <UserCommentRow
          dragStatus={dragStatus}
          callId={call.id}
          comments={comments.get(sessionUser.id, List())}
          sessionUser={sessionUser}
          setNewComment={setNewComment}
          directReports={directReports}
          setTimeSeconds={setTimeSeconds}
          playRecording={playRecording}
          {...playerProps}
        />
        {sessionUser.id !== call.caller.id && comments.has(call.caller.id) && (
          <UserCommentRow
            dragStatus={dragStatus}
            sessionUser={sessionUser}
            callId={call.id}
            comments={comments.get(call.caller.id, List())}
            directReports={directReports}
            setTimeSeconds={setTimeSeconds}
            playRecording={playRecording}
            {...playerProps}
          />
        )}
        {comments
          .delete(sessionUser.id)
          .delete(call.caller.id)
          .map((comments, userId) => (
            <UserCommentRow
              callId={call.id}
              sessionUser={sessionUser}
              key={userId}
              comments={comments}
              directReports={directReports}
              setTimeSeconds={setTimeSeconds}
              playRecording={playRecording}
              {...playerProps}
            />
          ))
          .toList()}
      </div>
    </div>
  );
};
